module.exports = __webpack_public_path__ + "static/peter-ef2861a9fd28ae22bfbce1d8730116d3.jpg";